import { WalletAddressType } from "@lib/types/Billing";
import * as yup from "yup";

export const productSchema = yup.object().shape({
  name: yup.string().required().min(3),
  description: yup.string().nullable(),
  currency: yup.string().required().oneOf(Object.values(WalletAddressType)),
  unitPrice: yup.number().required(),
});
